import { objectUtils, stringUtils } from '@festina-life/core'
import type { MouseEvent, ReactNode } from 'react'

import { Button } from '../../actions/button/Button'

type Props<T> = {
  /**
   * The selected value
   */
  values?: T[]
  disabled?: boolean
  /**
   * Function for rendering the contents of an item in the list
   */
  renderFn?: (items: T) => string | ReactNode
  /**
   * A callback to handle when a option is selected
   */
  /**
   * Function for retrieving the key for an item in the list
   */
  keyFn?: (items: T) => string | undefined
  onChange?: (event: MouseEvent<HTMLButtonElement>, value: T[]) => void
}

export const MultiSelectedOptions = <T,>({
  values,
  disabled = false,
  renderFn = (entry) => (entry ? `${entry}` : ''),
  keyFn = (entry: T) => objectUtils.objectToSortedString(entry),
  onChange,
}: Props<T>) => (
  <>
    {!!values?.length && (
      <div className="flex flex-wrap gap-1 pt-1">
        {values.map((value) => (
          <Button
            key={keyFn(value)}
            variant="secondary"
            onClick={(evt) => {
              if (!disabled) {
                onChange?.(
                  evt,
                  values.filter((x) => x !== value),
                )
              }
            }}
            className="whitespace-normal! break-all"
            endIcon={!disabled && onChange ? 'XMark' : undefined}
          >
            {stringUtils.makePaddingSpacesWider(renderFn(value))}
          </Button>
        ))}
      </div>
    )}
  </>
)
